import { render } from "./demand.vue?vue&type=template&id=3ca268d1&scoped=true"
import script from "./demand.vue?vue&type=script&lang=js"
export * from "./demand.vue?vue&type=script&lang=js"

import "./demand.vue?vue&type=style&index=0&id=3ca268d1&scoped=true&lang=css"

import exportComponent from "D:\\work\\code\\tranWorld\\traneasy-reply(易回复官网)\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ca268d1"]])

export default __exports__